// extracted by mini-css-extract-plugin
module.exports = {"root":"_2DuBG-hCfOPfir5vgGN-E5","border":"_1eagdJG48fzWHYTPAfPKUn","itemComponent":"AVoSCjg0cqZCQNSASg9L"};